import { useCallback, useSyncExternalStore } from 'react';

/**
 * Aktiver Stock je Welt (Phase 9: mehrere Stoecke). Kleiner externer Store, damit Karte, Stockseite
 * und Panels dieselbe Auswahl sehen; in localStorage gemerkt.
 */
const listeners = new Set<() => void>();
const key = (worldId: number) => `bk:activeHive:${worldId}`;

function read(worldId: number): number | null {
  try {
    const v = localStorage.getItem(key(worldId));
    return v ? Number(v) : null;
  } catch {
    return null;
  }
}

export function setActiveHive(worldId: number, hiveId: number) {
  try {
    localStorage.setItem(key(worldId), String(hiveId));
  } catch {
    /* privat/gesperrt: dann eben nur fuer diese Ansicht */
  }
  for (const l of listeners) l();
}

export function useActiveHiveId(worldId: number): number | null {
  const subscribe = useCallback((cb: () => void) => {
    listeners.add(cb);
    return () => listeners.delete(cb);
  }, []);
  return useSyncExternalStore(
    subscribe,
    () => read(worldId),
    () => null,
  );
}

/** Aktiven Stock aus der Liste waehlen; faellt auf den ersten zurueck, wenn die Auswahl nicht (mehr) existiert. */
export function pickActive<T extends { id: number }>(
  hives: T[] | undefined,
  activeId: number | null,
) {
  if (!hives || hives.length === 0) return undefined;
  return hives.find((h) => h.id === activeId) ?? hives[0];
}
